import { render, staticRenderFns } from "./GeneSymbolReviewList.vue?vue&type=template&id=61441167&scoped=true"
import script from "./GeneSymbolReviewList.vue?vue&type=script&lang=js"
export * from "./GeneSymbolReviewList.vue?vue&type=script&lang=js"
import style0 from "./GeneSymbolReviewList.vue?vue&type=style&index=0&id=61441167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61441167",
  null
  
)

export default component.exports